import { IApiResponse } from '../interfaces/IApiResponse';
import urls from './urls';
import axios, { AxiosResponse } from 'axios';

const configApp = require('../../app');

const isNative = !configApp || !configApp.isWebApp;

interface LogData {
  type: string;
  category: string;
  message: string;
  stackTrace?: string;
}

class LogApi {
  static addLog(data: LogData): Promise<IApiResponse> {
    const { type, category, message, stackTrace } = data;
    return axios.post(
      urls.LOG_CONNECTION,
      {
        type,
        category,
        message,
        stackTrace,
        isNative,
      },
      { baseURL: urls.BASE_URL, headers: { isAnonymous: false } }
    );
  }
}

export default LogApi;
